import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import useGuidedFlowVm from '|/app/guided-flow/use-guided-flow-vm';

const GuidedFlow = () => {
  const newRoute = useGuidedFlowVm();
  const { state } = useLocation();
  return newRoute === null ? null : (
    <Navigate to={newRoute} replace={true} state={state} />
  );
};

export default GuidedFlow;
